import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06087aee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "container"
}
const _hoisted_2 = { class: "dashboard-button" }
const _hoisted_3 = { style: {"text-align":"left"} }
const _hoisted_4 = { id: "small" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Log out", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoutVariant = _resolveComponent("LogoutVariant")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (!_ctx.store.state.isMobile)
    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("button", {
          id: "toggle",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args))),
          class: _normalizeClass({ active: _ctx.isActive })
        }, [
          _createElementVNode("div", {
            class: "photo",
            style: _normalizeStyle({'background-image': 'url('+ (_ctx.store.state.photoUrl || _ctx.placeholderImg) +')'})
          }, null, 4)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["dashboard-container", { opened: _ctx.isActive }])
        }, [
          _createElementVNode("button", _hoisted_2, [
            _createElementVNode("div", {
              class: "photo",
              style: _normalizeStyle({'background-image': 'url('+ (_ctx.store.state.photoUrl || _ctx.placeholderImg) +')'})
            }, null, 4),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", null, _toDisplayString(_ctx.store.state.email), 1),
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.isAdmin ? "ADMIN" : "ARTIST"), 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "dashboard-button",
            id: "logout",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
          }, [
            _createVNode(_component_LogoutVariant, { style: {"font-size":"32px"} }),
            _hoisted_5
          ])
        ], 2)
      ])), [
        [_directive_click_outside, _ctx.hide]
      ])
    : _createCommentVNode("", true)
}